module.exports = __webpack_public_path__ + "img/country-rules.ac9e2eda.svg";